import React from 'react'
import BackButton from '../../../../components/BackButton'
import LanguageStrings from '../../../../i18n/locales'
import { useNavigate } from 'react-router-dom'
import RegularKekInformation from './RegularKekInformation'
import { Button } from '../../../../components/Button'
import { Card, CircularProgress } from '@mui/material'
import { type Option } from '../../../../components/GenXDropdown'
import Modal from '../../../../components/Modal'
import { type CreateRegularKekPostRequest } from '../../types'
import { createRegularKek } from '../../redux/actionCreator'
import { type RootState } from '../../../../store'
import { type ConnectedProps, connect } from 'react-redux'
import AuthError from '../../../../components/ErrorComponents/AuthError'
import { type CreateRegularKekState } from '../../redux/createRegularKekSlice'

const CreateKekComponentStrings = LanguageStrings().HSMConfiguration.CreateRegularKekComponent

const AddRegularKekComponent = (props: PropsFromRedux): JSX.Element => {
  const [label, setLabel] = React.useState('')
  const [tenant, setTenant] = React.useState<Option | null>(null)
  const [use, setUse] = React.useState<Option | null>(null)
  const [error, setError] = React.useState<boolean>(false)
  const [descError, setDescError] = React.useState<boolean>(false)
  const [showConfirmation, setShowConfirmation] = React.useState(false)
  const [showCreatePopup, setShowCreatePopup] = React.useState(false)
  const [nameErrorInit, setNameErrorInit] = React.useState(false)
  const [tenantOptions, setTenantOptions] = React.useState<Option[]>([])
  const [useOptions, setUseOptions] = React.useState<Option[]>([])
  const navigate = useNavigate()

  const resetGroupState = (): void => {
    setLabel('')
    setTenant(null)
    setUse(null)
    setError(false)
    setDescError(false)
    setNameErrorInit(false)
  }

  const handeleCancelClick = (): void => {
    resetGroupState()
    navigate(-1)
  }

  const handleCreateKek = (): void => {
    props.createKek({
      label,
      tenant: tenant !== null ? tenant.value : '',
      use: use !== null ? use.value : ''
    })
  }

  const checkIfKekInfoValid = (): boolean => {
    return (label !== '' && tenant !== null && use !== null && !error && !descError)
  }

  const handleCreateKekWithFailure = (): JSX.Element => {
    if (props.createKekState.httpStatus === 201) {
      return (
                <Modal buttonTypeNegative='hollow' title={CreateKekComponentStrings.Successfully_created} LabelPositive={CreateKekComponentStrings.Ok} onClickPositive={() => { navigate('/hsm-regular-kek-configuration') }}
                       onClose={() => { navigate('/hsm-regular-kek-configuration') }}>
                    <p style={{ paddingTop: '1.2em' }}>{CreateKekComponentStrings.Regular_kek_has_been_created_successfully}</p>
                </Modal>
      )
    } else if (props.createKekState.isLoading) {
      return (
                <Modal title={CreateKekComponentStrings.Create_regular_KEK}>
                    <div className='CircularprogressAmi'>
                        <CircularProgress />
                    </div>
                </Modal>
      )
    } else if (props.createKekState.httpStatus === 401) {
      return (
                <Modal titleStyle={{ paddingRight: '2em' }} width={'fit-content'} height={'fit-content'} buttonTypeNegative='hollow' LabelNegative={CreateKekComponentStrings.Close}
                       onClickNegative={() => { setShowCreatePopup(false) }}
                       onClose={() => { setShowCreatePopup(false) }} title={CreateKekComponentStrings.Creating_regular_KEK}>
                    <div className='authError'>
                        <AuthError className={'errorCompInsideModal'} errorMessage="Unauthorized"/>
                    </div>
                </Modal>
      )
    } else if (props.createKekState.httpStatus === 403) {
      return (
                <Modal titleStyle={{ paddingRight: '2em' }} width={'fit-content'} height={'fit-content'} buttonTypeNegative='hollow' LabelNegative={CreateKekComponentStrings.Close}
                       onClickNegative={() => { setShowCreatePopup(false) }}
                       onClose={() => { setShowCreatePopup(false) }} title={CreateKekComponentStrings.Creating_regular_KEK}>
                    <div className='authError'>
                        <AuthError className={'errorCompInsideModal'} errorMessage="accessForbidden"/>
                    </div>
                </Modal>
      )
    } else if (props.createKekState.httpStatus === 400 && props.createKekState.error === 'A KEK with the specified label already exists in the HSM ') {
      return (
                <Modal width={'fit-content'} height={'fit-content'} buttonTypeNegative='hollow' LabelNegative={CreateKekComponentStrings.Close}
                       onClickNegative={() => { setShowCreatePopup(false) }}
                       onClose={() => { setShowCreatePopup(false) }} title={CreateKekComponentStrings.Creating_regular_KEK}>
                    <div className='authError'>
                        <AuthError className={'errorCompInsideModal'} customError={props.createKekState.error} />
                    </div>
                </Modal>
      )
    } else {
      return (
                <Modal width={'fit-content'} height={'fit-content'} buttonTypeNegative='hollow' LabelNegative={CreateKekComponentStrings.Close}
                       onClickNegative={() => { setShowCreatePopup(false) }}
                       onClose={() => { setShowCreatePopup(false) }} title={CreateKekComponentStrings.Creating_regular_KEK}>
                    <div className='authError'>
                        <AuthError className={'errorCompInsideModal'} customError={props.createKekState.error} />
                    </div>
                </Modal>
      )
    }
  }

  return (
        <div style={{ width: 'calc(100vw - 3.5rem)', paddingRight: '2rem' }}>
            <div className='link-breadcrumb'>
                <span data-testid='assetManagementbreadcrumb' onClick={ () => { navigate('/card') }} className='assetmgmtli'>{CreateKekComponentStrings.HSMKeyManagement}</span>
                <span style={{ padding: '0 0.5em' }}>/</span>
                <span onClick={() => { navigate('/hsm-regular-kek-configuration') }} className='assetmgmtli'>{CreateKekComponentStrings.HSMKeks}</span>
                <span style={{ padding: '0 0.5em' }}>/</span>
                <span>{CreateKekComponentStrings.AddRegularKEK}</span>
            </div>
            <div className='topUtilityBar'>
                <BackButton/>
                <span id='componentTitle' data-testid='create-group'>{CreateKekComponentStrings.Creating_regular_KEK}</span>
            </div>
            <br />
            {
                        <Card sx={{ borderRadius: '10px', backgroundColor: '#272727', color: '#F0F0F0 !important', padding: '25px', overflow: 'visible' }}>
                            <div style={{ height: 2, borderTop: '2px solid #707070', width: '100%', margin: '20px 0' }}></div>
                            <RegularKekInformation
                                error={error}
                                setError={setError}
                                label={label}
                                setLabel={setLabel}
                                tenant={tenant}
                                setTenant={setTenant}
                                use={use}
                                setUse={setUse}
                                setNameErrorInit={setNameErrorInit}
                                nameErrorInit={nameErrorInit} tenantOptions={tenantOptions} setTenantOptions={setTenantOptions} useOptions={useOptions} setUseOptions={setUseOptions}/>
                        </Card>
            }
            <div style={{ width: '100%', height: '80px', backgroundColor: '#272727', margin: '50px 0 10px 0', borderRadius: 10 }}>
                <div style={{ height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1em' }}>
                    <div>
                        <Button type='hollow' onClick={() => { handeleCancelClick() }}>{CreateKekComponentStrings.Cancel}</Button>
                    </div>
                        {

                                <Button dataTestId='next-btn-select'
                                                                                  primaryColor={checkIfKekInfoValid() ? undefined : '#B0B0B0'}
                                                                                  disabled={!checkIfKekInfoValid()}
                                                                                  onClick={() => {
                                                                                    setShowConfirmation(true)
                                                                                  }}>
                                {CreateKekComponentStrings.Create}
                            </Button>

                        }
                </div>
            </div>
            { showConfirmation &&
                <Modal buttonTypeNegative='hollow' title={CreateKekComponentStrings.Create} LabelNegative={CreateKekComponentStrings.Cancel} LabelPositive={CreateKekComponentStrings.Create} onClickPositive={() => {
                  setShowConfirmation(false)
                  setShowCreatePopup(true)
                  handleCreateKek()
                }} onClose={() => { setShowConfirmation(false) }} onClickNegative={() => { setShowConfirmation(false) }}>
                    <p style={{ paddingTop: '1.2em' }}>{CreateKekComponentStrings.DoYouWantToCreateThisRegularKek}</p>
                </Modal>
            }
            {
                showCreatePopup &&
                handleCreateKekWithFailure()
            }
        </div>
  )
}

interface DispatchToProps {
  createKek: (createRegularKekPostRequest: CreateRegularKekPostRequest) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  createKek: (createGroupPostRequest: CreateRegularKekPostRequest) => dispatch(createRegularKek(createGroupPostRequest))
})

interface StateToProps {
  createKekState: CreateRegularKekState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  createKekState: state.createKekState
})

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AddRegularKekComponent)
export { AddRegularKekComponent as UnconnectedAddRegularKekComponent }
